/** Alteração na lista de produtos da compra que pode exigir confirmação (cotação já enviada ou respondida). */
export enum AcaoAlteracaoProdutoEnum {
  Incluir = 1,
  Remover = 2,
}
